define('views/modules/calendar/nutrition/food/recipe/recipe-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // services
    'services/viewport',
    'services/layout',
    // models
    'models/calendar/nutrition/recipe',
    // views
    'views/parts/panel/base-panel',
    'views/modules/calendar/nutrition/food/recipe/recipe-content',

], function(
    // Libs
    _, Backbone, U,
    // services
    Viewport,
    LayoutState,
    // models
    MRecipe,
    // views
    VBasePanel,
    VRecipeContent
) {

    var VRecipePanel = VBasePanel.extend({
        header: {
            title: "Recipe editor",
            subtitle: "Create/Edit a custom recipe",
        },
        tabs: [{ id: 'details', title: 'Edit', icon: 'sl-icon-note', active: true }],
        content: { details: VRecipeContent, },
        defaultView: 'details',
        initialize: function(opt) {
            this.model = this.model || new MRecipe();
            var details = this.getView('details', { model: this.model });
            this.listenTo(details, {
                'form:success': this.close,
                "drawer:view": this.onSetDrawerView
            });
        },

        resetModel: function(attrs) {
            this.model.reset(attrs);
            return this;
        },

        ////////////
        // events //
        ////////////
        onOpen: function(open) {
            var view = this.view,
                details = view.details;
            if (view.layout.is(details) && !Viewport.isMobile() && this.model.isNew() && open) {
                details.toggleFoodPanel(true);
            }
        },

        // onExpandPanel: function() {
        //     if (LayoutState.isFull('info')) {
        //         LayoutState.toggleInfoFull();
        //     } else {
        //         this.view.details.toggleFoodPanel(true);
        //     }
        // },

        onSetDrawerView: function(view, open) {
            this.trigger("drawer:view", view, open);
        },

    });

    return VRecipePanel;
});

